import Image from 'next/image'
import Link from 'next/link'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'

import cl from './style.module.scss'

export interface serviceItems {
	link: {
		label: string
		href: string
	}
	title: string
	subtitle: string[]
	image: string
}

export const ServiceToday = (props: { items: serviceItems[] }) => {
	const { items } = props
	return (
		<section className={cl.service}>
			<div className={cl.wrapper}>
				<h2 className={cl.title}>Сервис iPort сегодня</h2>
				<ul className={cl.list}>
					{items.map(({ link, title, subtitle, image }) => (
						<li className={cl.item} key={link.href}>
							<div className={cl.top}>
								<Link prefetch={false} href={link.href} className={cl.link}>
									{link.label}
								</Link>
								<h4 className={cl.label} dangerouslySetInnerHTML={createMarkup(title)} />
								{subtitle.map((item, index) => (
									<p className={cl.text} key={index} dangerouslySetInnerHTML={createMarkup(item)} />
								))}
							</div>
							<div className={cl.bot}>
								<Image src={image} alt={'ноут'} width={385} height={250} className={cl.image} />
							</div>
						</li>
					))}
				</ul>
			</div>
		</section>
	)
}
